export default __webpack_public_path__ + "static/tabs-grouping-do-2b6b9a9ce7b90c2af7110e8e2f3dce5e070aa175a1c053dd37c7a70eb6453eec.png";